export enum PainIntensity {
  NO_PAIN = 'NO_PAIN',
  SOFT = 'SOFT',
  MODERATE = 'MODERATE',
  INTENSE = 'INTENSE',
  STRONG = 'STRONG',
  UNBEARABLE = 'UNBEARABLE'
}
